// Constants used throughout the workers-channel client

export const MESSAGE_TYPES = {
  MESSAGE: 'message',
  REQUEST: 'request',
  RESPONSE: 'response',
} as const

export const CLIENT_STATES = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
} as const

export const ENCODING_FORMATS = {
  HEX: 'hex',
  BASE64: 'base64',
} as const

export const CRYPTO_CONSTANTS = {
  IV_LENGTH: 12,
  AES_KEY_LENGTH: 32,
  SALT_LENGTH: 32,
  ED25519_PUBLIC_KEY_LENGTH: 32,
  ED25519_PRIVATE_KEY_LENGTH: 32,
} as const

export const TIMING_CONSTANTS = {
  DEFAULT_CALL_TIMEOUT: 120 * 1000,
  DEFAULT_HTTP_CALL_TIMEOUT: 60 * 1000,
  DEFAULT_CONSUME_INTERVAL: 15000,
  WEBSOCKET_KEEPALIVE_INTERVAL: 20000,
  WEBSOCKET_RECONNECT_DELAY: 1000,
  MESSAGE_EXPIRE_TIME: 2 * 60 * 1000,
} as const

export const TRANSPORT_MODES = {
  WS: 'ws',
  HTTP: 'http',
  AUTO: 'auto',
} as const

export type TransportMode = (typeof TRANSPORT_MODES)[keyof typeof TRANSPORT_MODES]

export const LOCAL_CALL_TARGET = 'local'

export const ERROR_CODES = {
  SUCCESS: 0,
  INTERNAL_ERROR: 500,
  TIMEOUT: 408,
  NOT_FOUND: 404,
  VALIDATION_ERROR: 400,
} as const

export const WS_CLOSE_CODES = {
  DISPLACED: 4000,
  DUPLICATE_REJECTED: 4001,
} as const
